import './locales/i18n';
// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
// contexts
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { SettingsProvider } from './contexts/SettingsContext';
//
import App from './App';
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import RtlLayout from './components/RtlLayout';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeLocalization from './components/ThemeLocalization';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { AuthProvider } from './contexts/JWTContext';
import { ApiProvider } from './contexts/api-provider';
import ThemeProvider from './theme';

ReactDOM.render(
  <ThemeProvider>
    <NotistackProvider>
      <AuthProvider>
        <ApiProvider>
          <ThemeColorPresets>
            <ThemeLocalization>
              <HelmetProvider>
                <SettingsProvider>
                  <RtlLayout>
                    <MotionLazyContainer>
                      <CollapseDrawerProvider>
                        <BrowserRouter>
                          <ProgressBarStyle />
                          <App />
                        </BrowserRouter>
                      </CollapseDrawerProvider>
                    </MotionLazyContainer>
                  </RtlLayout>
                </SettingsProvider>
              </HelmetProvider>
            </ThemeLocalization>
          </ThemeColorPresets>
        </ApiProvider>
      </AuthProvider>
    </NotistackProvider>
  </ThemeProvider>,
  document.getElementById('root')
);
